import { render, staticRenderFns } from "./ContactFormRadio.vue?vue&type=template&id=7442247c&scoped=true&"
import script from "./ContactFormRadio.vue?vue&type=script&lang=js&"
export * from "./ContactFormRadio.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormRadio.vue?vue&type=style&index=0&id=7442247c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442247c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
